export default {
    namespaced: true,

    state: {
        Name: null,
        Email: null,
        Phone: null,
        Identity: null,
        IdentityType: null,
        PhoneCountry: null,
        CountryCode: null,
        AcceptAds: false,
        UserAgent: window.navigator.userAgent ? window.navigator.userAgent : null,
    },

    getters: {
        /**
		 * Monta o contrato de autorização
		 */
        getSubmitModel(state, getters, rootState, rootGetters) {
            return {
                Guest: {
                    FullName: state.Name,
                    Email: state.Email,
                    Phone: state.Phone,
                    Identity: state.Identity,
                    IdentityType: state.IdentityType,
                    PhoneCountry: state.PhoneCountry,
                    CountryCode: state.CountryCode,
                    AcceptAds: state.AcceptAds,
                    UserAgent: state.UserAgent
                }
            };
        },

        getCustomerFirstDigits(state) {
            return state.Identity? state.Identity.slice(0, 3): '***';
        },

        getCustomerName(state) {
            return state.Name? state.Name: '';
        },
    },

    mutations: {
        setName: (state, name) => (state.Name = name),
        setEmail: (state, email) => (state.Email = email),
        setPhone: (state, phone) => (state.Phone = phone),
        setIdentity: (state, identity) => (state.Identity = identity),
        setIdentityType: (state, identityType) => (state.IdentityType = identityType),
        setPhoneCountry: (state, phoneCountry) => (state.PhoneCountry = phoneCountry),
        setCountryCode: (state, countryCode) => (state.CountryCode = countryCode),
        setAcceptAds: (state, acceptAds) => (state.AcceptAds = acceptAds),

        setFromRequest(state, data) {
            if (!data) return;
            state.Name = data.Name || data.FullName || null;
            state.Email = data.Email || null;
            state.Phone = data.Phone || null;
            state.Identity = data.Identity || null;
            state.IdentityType = data.IdentityType || 'CPF';
            state.PhoneCountry = data.PhoneCountry || null;
            state.CountryCode = data.CountryCode || null;
            state.AcceptAds = data.AcceptAds || false;
        }
    }
};
